export default __webpack_public_path__ + "static/media/sdg-6-load.8117ab32.png";